/**
 * Origine du texte à améliorer.
 *
 * Le back expose une route par origine : le contexte confié au modèle n'est pas le même pour
 * un libellé de questionnaire et pour le corps d'un e-mail.
 */
export enum COMPLETION_SOURCE {
    SURVEY = 'SURVEY',
    EMAIL = 'EMAIL',
}
